import React from "react";
import "./Greeting.css";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { greeting } from "../../portfolio";
import { Fade } from "react-reveal";
import FeelingProud from "./FeelingProud";

export default function Greeting(props) {
  const theme = props.theme;
  return (
    <Fade bottom duration={2000} distance="40px">
      <div className="greet-main" id="greeting" color="red">
        <div className="greeting-main" >
          <div className="greeting-text-div">
            <div>
              <h1 className="greeting-text" style={{ color: theme.text }}>
                {greeting.title}
              </h1>
              {greeting.nickname && (
                <h2 className="greeting-nickname" style={{ color: theme.text }}>
                  ( {greeting.nickname} )
                </h2>
              )}
              <p
                className="greeting-text-p subTitle"
                style={{ color: theme.secondaryText }}
              >
                {greeting.subTitle}
              </p>
              {/* <p 
                // className="greeting-text-p subTitle"
                style={{ color: theme.secondaryText, fontSize: '30px' }}
              >
                I am Wilson, an Electrical and Computer Engineering student specializing 
                in robotics at the University of California, San Diego (UCSD). 
                I have taken courses in sensing and estimation, motion planning, and visual learning, 
                where I learned about particle filters, visual-inertial SLAM, model-free prediction/control, and computer vision. 
                I have 3+ years of programming experience in C++/Python and developed a LiDAR-based detection system for autonomous mobile robots during my internship. 
                Additionally, I have research experience in deep learning, specifically in computer vision, natural language processing, and multi-modal learning. 
                Prior to my Master's, I completed my Bachelor's in Mechanical Engineering at National Taiwan University, where I worked on projects involving autonomous mobile robots for disinfection and unsupervised anomalous sound detection.
              </p> */}
              <SocialMedia theme={theme} />
              {/* <div className="portfolio-repo-btn-div">
                <Button
                  text="⭐ Star Me On Github"
                  newTab={true}
                  href={greeting.portfolio_repository}
                  theme={theme}
                  className="portfolio-repo-btn"
                />
              </div> */}
              {/* <div className="button-greeting-div">
              <Button text="Contact me" href="#contact" />
              <Button text="See my resume" newTab={true} href={greeting.resumeLink} />
            </div> */}
            </div>
          </div>
          <div className="greeting-image-div">
            {/* <img
							alt="saad sitting on table"
							src={require("../../assests/images/feelingProud.svg")}
						></img> */}
            <FeelingProud theme={theme} />
          </div>
        </div>
      </div>
    </Fade>
  );
}
